<script>
/*
<template functional>
  <div>
    <small v-if="props.model.$error" class="text-sm text-danger">{{props.model.$error}}</small>
  </div>
</template>

*/
export default {
  props: ['model'],
  render(h, context) {
    const err = this.model.$error;
    return h('div', {}, err ? [h('small', { class: 'text-sm text-danger' }, err)] : []);
  }
};
</script>
